/** @format */

import angular from 'angular';
import angularMaterial from 'angular-material';
import angularMaterialDataTable from 'angular-material-data-table';
import { UserModelsModule } from 'crowdcomms-js/lib/galabid/user/models';

import { GbEditTableItemsDialogService } from './gb-edit-table-items-dialog/gb-edit-table-items-dialog.service';
import { GbEditTeamScoringDialogService } from './gb-edit-team-scoring-dialog/gb-edit-team-scoring-dialog.service';

export const EditToolsDialogsModule = angular
    .module('galabid-presenter.components.edit-tools.dialogs', [
        angularMaterial,
        angularMaterialDataTable,
        UserModelsModule,
    ])
    .service('$gbEditTableItemsDialog', GbEditTableItemsDialogService)
    .service('$gbEditTeamScoringDialog', GbEditTeamScoringDialogService).name;
